import type { PrintLayer } from "../print/PrintLayer"

export type LayerMap = Record<string, PrintLayer>
